









import Vue from "vue";

export default Vue.extend({
  // data() {
  //   return {
  //     selected: this.$store.state.lang, // 言語設定の初期値(jaまたはen)
  //   };
  // },
  computed: {
    selected() {
      return this.$store.getters.getLang;
    },
  },
  created() {
    this.$forceUpdate();
  },
  methods: {
    onChangeLang(event: Event) {
      // 言語の設定が変わったことを親に伝える
      this.$i18n.set(String(event));
      this.$store.state.lang = event;
      this.$emit("selectLangEvent", String(event));
    },
  },
});
